import { defineSchema } from '../../schema-meta.ts';
import { registerCategorySchema } from '../../registry.ts';

/**
 * Server-side item catalogue. Used by server score code to:
 *   1. Resolve purchased wave-shop itemId → metaTagIds (for synergy counting).
 *   2. Apply HP-bearing stats from items to the authoritative max-HP calculation.
 *
 * Client-only display fields (name, icon, description, category, skills, …) are
 * omitted — they live in `clientItems` and never reach this seed.
 */
export const ItemSchema = defineSchema({
  name: 'serverItems',
  fields: [
    ['id', 'number'],
    ['metaTagIds', { kind: 'array', of: 'number' }],
    ['stats', { kind: 'record', value: 'number' }],
  ],
  lookupKeys: ['id'],
});

export interface RawItemRow {
  id: number;
  meta_tag_ids?: number[] | null;
  stats?: Record<string, unknown> | null;
}

export function itemFromRaw(row: RawItemRow): {
  id: number;
  metaTagIds: number[];
  stats: Record<string, number>;
} {
  const stats: Record<string, number> = {};
  for (const [k, v] of Object.entries(row.stats ?? {})) {
    const n = Number(v);
    if (Number.isFinite(n) && n !== 0) stats[k] = n;
  }
  return {
    id: row.id,
    metaTagIds: (row.meta_tag_ids ?? []).filter((x): x is number => typeof x === 'number'),
    stats,
  };
}

registerCategorySchema('serverItems', ItemSchema);
